import { render, staticRenderFns } from "./coverInput.vue?vue&type=template&id=494b9abf&scoped=true"
import script from "./coverInput.vue?vue&type=script&lang=js"
export * from "./coverInput.vue?vue&type=script&lang=js"
import style0 from "./coverInput.vue?vue&type=style&index=0&id=494b9abf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b9abf",
  null
  
)

export default component.exports